<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Header Section -->

        <div class="container-fluid">
          <div class="row align-items-center py-4">
            <div class="col-12">
              <!-- Alert de advertencia -->
              <div
                v-if="showAlert && this.$store.state.user.status !== 1"
                class="alert alert-warning alert-dismissible fade show shadow-sm mb-4"
                role="alert"
              >
                <div class="d-flex align-items-center">
                  <i class="fas fa-exclamation-triangle fa-2x mr-3"></i>
                  <div>
                    <h5 class="alert-heading mb-1">Atención requerida</h5>
                    <p class="mb-0">
                      Por favor comunicarse con un administrador de frontera.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Título de bienvenida -->
              <div class="text-center">
                <h4 class="font-weight-bold text-dark">
                  BIENVENIDO {{ this.$store.state.user.name.toUpperCase() }}
                </h4>
                <hr class="w-100 border-dark" />
              </div>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <section class="content" v-if="this.$store.state.user.status == 1">
          <div class="container-fluid">
            <!-- Card principal -->
            <div class="card shadow-lg border-0">
              <div class="card-header bg-geogo-top-left text-white py-4">
                <div class="d-flex align-items-center">
                  <i class="fas fa-th-large fa-2x mr-3"></i>
                  <div>
                    <h4 class="mb-0 font-weight-bold">
                      Selecciona un módulo para iniciar
                      {{ this.$store.state.user.name }}
                    </h4>
                    <small style="opacity: 0.75;"
                      >Elige una línea de negocio para continuar</small
                    >
                  </div>
                </div>
              </div>

              <div class="card-body p-4">
                <div class="row justify-content-center">
                  <template v-for="linea in $store.state.user.lineas_negocio">
                    <div
                      class="col-lg-4 col-md-6 mb-4"
                      v-if="linea.mostrar_menu == 1"
                      :key="linea.id"
                    >
                      <!-- Card de línea de negocio modernizada -->
                      <div
                        class="card h-100 shadow-sm hover-card border border-default"
                        @click="irLineaNegocio(linea)"
                        style="cursor: pointer; transition: all 0.3s ease;"
                      >
                        <!-- Header con gradiente -->
                        <div
                          class="card-header bg-geogo-top-left text-white py-4 position-relative overflow-hidden"
                        >
                          <div
                            class="position-absolute"
                            style="top: -50px; right: -50px; width: 150px; height: 150px; background: rgba(255,255,255,0.1); border-radius: 50%;"
                          ></div>
                          <div
                            class="position-absolute"
                            style="bottom: -30px; left: -30px; width: 100px; height: 100px; background: rgba(255,255,255,0.1); border-radius: 50%;"
                          ></div>
                          <div class="position-relative">
                            <div
                              class="d-flex justify-content-between align-items-start"
                            >
                              <div>
                                <h5 class="mb-1 font-weight-bold">
                                  <i class="fas fa-building mr-2"></i>GeoGo
                                </h5>
                                <p class="mb-0" style="opacity: 0.9;">
                                  {{ linea.cod_alterno }}
                                </p>
                              </div>
                              <div
                                class="rounded-circle p-2"
                                style="background: rgba(255,255,255,0.2);"
                              >
                                <i class="fas fa-arrow-right"></i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Body -->
                        <div class="card-body p-4">
                          <div class="d-flex justify-content-center">
                            <button
                              class="btn btn-lg btn-block shadow-sm font-weight-bold text-white"
                              style="border-radius: 50px; background: linear-gradient(to bottom, #000000, #6f7174); border: none;"
                            >
                              <i class="fas fa-eye mr-2"></i>
                              Ver más
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <!-- Mensaje cuando no hay líneas de negocio -->
                <div
                  v-if="
                    !$store.state.user.lineas_negocio ||
                      $store.state.user.lineas_negocio.filter(
                        (l) => l.mostrar_menu == 1
                      ).length === 0
                  "
                  class="text-center py-5"
                >
                  <i class="fas fa-inbox fa-4x text-muted mb-3"></i>
                  <h5 class="text-muted">No hay módulos disponibles</h5>
                  <p class="text-muted">
                    Contacta con un administrador para obtener acceso.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<style scoped>
/* Efecto hover para las cards */
.hover-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.hover-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.hover-card:hover .card-header {
  background: linear-gradient(to bottom, #1a1a1a, #7a7c7f) !important;
}

.hover-card:hover button {
  background: linear-gradient(to bottom, #1a1a1a, #7a7c7f) !important;
  transform: scale(1.02);
}

/* Animación suave para el contenido */
.content {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mejoras de accesibilidad */
.card {
  border-radius: 12px;
  overflow: hidden;
}

.card-header {
  border-bottom: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .display-4 {
    font-size: 2rem;
  }

  .lead {
    font-size: 1rem;
  }
}
</style>
<script>
import Loading from "../components/Loading";
export default {
  name: "Home",
  components: {
    Loading,
  },
  data() {
    return {
      cargando: false,
      showAlert: false,
    };
  },

  watch: {
    "$store.state.user.status": {
      immediate: true,
      handler(newStatus) {
        if (newStatus !== 1) {
          this.showAlert = true;
          setTimeout(() => {
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }, 5000);
        }
      },
    },
  },

  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    async irLineaNegocio(linea_negocio) {
      this.cargando = true;
      await this.$store.dispatch("getMenus", linea_negocio.id);
      await this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      await this.$store.dispatch("setRoutes");

      if (linea_negocio.id && linea_negocio.router) {
        this.cargando = false;
        return this.$router.replace(linea_negocio.router);
      } else {
        this.cargando = false;
        this.$swal({
          icon: "error",
          title: "Ocurrió un error",
          text: "No se encontró la ruta de la línea de negocio",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },
  },

  mounted() {
    this.toggleBodyClass("addClass", "sidebar-collapse");
    this.toggleBodyClass("removeClass", "sidebar-mini");
  },

  destroyed() {
    this.toggleBodyClass("removeClass", "sidebar-collapse");
    this.toggleBodyClass("addClass", "sidebar-mini");
  },
};
</script>
